export default __webpack_public_path__ + "static/media/edit-icon.86a7e1bd.svg";